<template>
    <div class="proj-card" v-if="ready && loaded" v-on:click="goRoute">
      <media-type :className="'proj-card-media'" :obj="projData.cover"  :dynAlt="projData.title[lang].name"> </media-type>

      <div class="proj-card-client">{{projData.client[0].name}}</div>
      <div class="proj-card-title">{{projData.title[lang].name}}</div>




    </div>
</template>

<script>



    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, PROJ, WP} from '../../main';
    import MediaType from "./MediaType";


    export default {

        name: 'ProjCard',
      components: {MediaType},
      props: ['projId',  'lang', 'actScreen', 'totalScreen', 'numScreen', 'scroll'],
        data() {
            return {
                projData: [],
                loaded: false,
                 ready: false,
                visited: false,

            }
        },

        created() {
          const _this = this;
          PROJ('id', this.projId, function (response){

            _this.projData = response[0];
            _this.loaded = true;
            _this.init();
            console.log( _this.projData)

          });


        },
      mounted() {

        //EVENTBUS.$on('AAA', AAA);
        //EVENTBUS.$emit('AAA', 0);


        this.ready = true;
        this.init();

      },

        destroyed() {

        },

        methods: {


              //EVENTBUS.$on('AAA', AAA);
              //EVENTBUS.$emit('AAA', 0);



            init(){

              if(this.loaded && this.ready){

                if(this.numScreen === 1){

                 //   this.animCase();
                }else{
                  this.visited = true;
                }

              }
            },



          goRoute(){

            if(this.scroll == 0) {
               // alert('dfdsf')
              }


            this.$router.replace( this.projData.route);
            this.$router.go();
          }


        },






    };

</script>


// WEBPACK FOOTER //
// src/components/Modules/ProjCard.vue